import React from 'react';
import {
  Portal,
  Spinner,
  Stack,
  Toast,
  Toaster as ChakraToaster,
  createToaster,
} from '@chakra-ui/react';

/**
 * App-wide toaster. Call `toaster.create({...})` anywhere to raise a message.
 * Render `<Toaster />` once, near the app root, or nothing appears.
 */
export const toaster = createToaster({
  placement: 'top-end',
  pauseOnPageIdle: true,
});

/**
 * Renders the toasts raised through `toaster`. Mount once, near the app root.
 */
export const Toaster = (): React.ReactElement => (
  <Portal>
    <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
      {(toast) => (
        <Toast.Root
          width={{ md: '380px' }}
          bg='gray.900'
          color='white'
          borderRadius='lg'
          padding='4'
        >
          {toast.type === 'loading' ? (
            <Spinner size='sm' color='white' />
          ) : (
            <Toast.Indicator color='white' />
          )}
          <Stack gap='1' flex='1' maxWidth='full'>
            {toast.title != null && (
              <Toast.Title fontSize='md' fontWeight='semibold'>
                {toast.title}
              </Toast.Title>
            )}
            {toast.description != null && (
              <Toast.Description fontSize='sm' opacity={0.9}>
                {toast.description}
              </Toast.Description>
            )}
          </Stack>
          <Toast.CloseTrigger color='white' />
        </Toast.Root>
      )}
    </ChakraToaster>
  </Portal>
);
